import { useToggleState } from "@src/utility_functions/customHooks/useToggleState.js";

export const ShowHideSection = (props) => {
  const [toggleExpandTrue, toggleExpand] = useToggleState(false);

  return (
    <div className="_margin-top--1rem">
      <button
        className={props.linkColor === "gray" ? "_color--var_gray-40_" : ""}
        onClick={toggleExpand}
      >
        {props.linkText}
        <i
          className={
            "fas fa-chevron-down rotate_90 _margin--0_1rem " +
            (toggleExpandTrue ? "active" : "")
          }
        ></i>
      </button>
      {props.parantheticalText && (
        <span className="_font-size--10pt"> {props.parantheticalText} </span>
      )}
      <hr className="_margin-top--5px _margin-bottom--1rem" />
      <div
        className={
          "_overflow--hidden _transition--all_0p5s " +
          (toggleExpandTrue ? "_max-height--5000px" : "_max-height--0")
        }
      >
        {props.children}
      </div>
    </div>
  );
};
